import React from 'react'
import Portal from '../../../../component/portal'
import { i18n, i18n_style, isValidEmail } from '../../../../common/util'
import ee, { EVENT_TIP, EVENT_CONFIRM } from '../../../../common/util/event'
import { submitGame } from './service'

class SubmitForm extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            firstName: '',
            firstNameTip: null,
            lastName: '',
            lastNameTip: null,
            email: '',
            emailTip: null,
            gameName: '',
            gameNameTip: null,
            description: '',
            descriptionTip: null,
            buildLink: '',
            // buildLinkTip: null,
            agree: false
        }
        this.submitFlag = false
    }

    inputFirstName = e => {
        this.setState({
            firstName: e.target.value
        })
    }

    inputLastName = e => {
        this.setState({
            lastName: e.target.value
        })
    }

    inputEmail = e => {
        this.setState({
            email: e.target.value
        })
    }

    inputGameName = e => {
        this.setState({
            gameName: e.target.value
        })
    }

    inputDescription = e => {
        this.setState({
            description: e.target.value
        })
    }

    inputBuildLink = e => {
        this.setState({
            buildLink: e.target.value
        })
    }

    checkFirstName = () => {
        const { firstName } = this.state
        if (!firstName || /^\s+$/.test(firstName)) {
            this.setState({
                firstNameTip: i18n('_required')
            })
            return false
        }
        this.setState({
            firstNameTip: null
        })
        return true
    }

    checkLastName = () => {
        const { lastName } = this.state
        if (!lastName || /^\s+$/.test(lastName)) {
            this.setState({
                lastNameTip: i18n('_required')
            })
            return false
        }
        this.setState({
            lastNameTip: null
        })
        return true
    }

    checkEmail = () => {
        const { email } = this.state
        if (!email || /^\s+$/.test(email)) {
            this.setState({
                emailTip: i18n('_required')
            })
            return false
        }
        if (!isValidEmail(email)) {
            this.setState({
                emailTip: i18n('_invalid_email')
            })
            return false
        }
        this.setState({
            emailTip: null
        })
        return true
    }

    checkGameName = () => {
        const { gameName } = this.state
        if (!gameName || /^\s+$/.test(gameName)) {
            this.setState({
                gameNameTip: i18n('_required')
            })
            return false
        }
        this.setState({
            gameNameTip: null
        })
        return true
    }

    checkDescription = () => {
        const { description } = this.state
        if (!description || /^\s+$/.test(description)) {
            this.setState({
                descriptionTip: i18n('_required')
            })
            return false
        }
        this.setState({
            descriptionTip: null
        })
        return true
    }

    checkAgreement = () => {
        const { agree } = this.state
        if (!agree) {
            ee.emit(EVENT_TIP, '_agreement')
            return false
        }
        return true
    }

    submit = () => {
        if (this.submitFlag) {
            return
        }
        const fn_flag = this.checkFirstName()
        const ln_flag = this.checkLastName()
        const e_flag = this.checkEmail()
        const gn_flag = this.checkGameName()
        const d_flag = this.checkDescription()
        if (!fn_flag || !ln_flag || !e_flag || !gn_flag || !d_flag) {
            return
        }
        if (!this.checkAgreement()) {
            return
        }
        this.submitFlag = true
        const { firstName, lastName, email, gameName, description, buildLink } = this.state
        submitGame(firstName, lastName, email, gameName, description, buildLink).then(() => {
            ee.emit(EVENT_CONFIRM, '_submit_success')
            this.setState({
                firstName: '',
                lastName: '',
                email: '',
                gameName: '',
                description: '',
                buildLink: '',
                agree: false
            })
        }).catch(e => {
            ee.emit(EVENT_TIP, '_submit_failed')
            console.error(e)
        }).finally(() => {
            this.submitFlag = false
        })
    }

    toggleAgreement = () => {
        const { agree } = this.state
        this.setState({
            agree: !agree
        })
    }

    render() {
        const {
            firstName,
            firstNameTip,
            lastName,
            lastNameTip,
            email,
            emailTip,
            gameName,
            gameNameTip,
            description,
            descriptionTip,
            buildLink,
            agree
        } = this.state
        return <div>
            <div className="submit-form-item">
                <div className="submit-form-label">{i18n('_first_name')}</div>
                <input type="text" name="submit-fn" className="submit-form-input"
                    placeholder={i18n('_first_name') + ' *'} value={firstName} onChange={this.inputFirstName}></input>
                {
                    firstNameTip && <div className='submit-form-tip'>{firstNameTip}</div>
                }
            </div>
            <div className="submit-form-item">
                <div className="submit-form-label">{i18n('_last_name')}</div>
                <input type="text" name="submit-ln" className="submit-form-input"
                    placeholder={i18n('_last_name') + ' *'} value={lastName} onChange={this.inputLastName}></input>
                {
                    lastNameTip && <div className='submit-form-tip'>{lastNameTip}</div>
                }
            </div>
            <div className="submit-form-item">
                <div className="submit-form-label">{i18n('_email')}</div>
                <input type="text" name="submit-e" className="submit-form-input"
                    placeholder={i18n('_email') + ' *'} value={email} onChange={this.inputEmail}></input>
                {
                    emailTip && <div className='submit-form-tip'>{emailTip}</div>
                }
            </div>
            <div className="submit-form-item">
                <div className="submit-form-label">{i18n('_game_name')}</div>
                <input type="text" name="submit-gn" className="submit-form-input"
                    placeholder={i18n('_game_name') + ' *'} value={gameName} onChange={this.inputGameName}></input>
                {
                    gameNameTip && <div className='submit-form-tip'>{gameNameTip}</div>
                }
            </div>
            <div className="submit-form-ta-wrapper">
                <div className="submit-form-ta-header" style={{ paddingLeft: i18n_style('36px', '60px') }}>{i18n('_game_description')}</div>
                <textarea className="submit-form-textarea" name="submit-d" placeholder={i18n('_game_description') + ' *'} value={description} onChange={this.inputDescription}></textarea>
                {
                    descriptionTip && <div className='submit-form-tip'>{descriptionTip}</div>
                }
            </div>
            <div className="submit-form-item link">
                <div className="submit-form-label">{i18n('_game_build_link')}</div>
                <input type="text" name="submit-bl" className="submit-form-input"
                    placeholder={i18n('_game_build_link')} value={buildLink} onChange={this.inputBuildLink}></input>
            </div>
            <div className="submit-form-agreement-wrapper">
                <p className="submit-form-agreement" onClick={this.toggleAgreement}>{i18n('_i_understand')}</p>
                <div className={agree ? 'submit-form-agreement-checkbox active' : 'submit-form-agreement-checkbox'} onClick={this.toggleAgreement}></div>
            </div>
            <div className="submit-form-btn-line">
                <button className="sbumit-form-btn" onClick={this.submit}>{i18n('_submit')}</button>
            </div>
        </div>
    }
}

export default Portal(SubmitForm, 'submit-form-container')